import {
  MaterialityTypes,
  PriorityLevel,
  SimpleMaterialityQuestionsArray_StakeFragment,
  useSimpleMaterialityQuestionsArray_QuestionQuery,
} from '@/graphql/generated';
import { LoaderFullscreen } from '@/components/layout/Loader';
import {
  MatrixArray,
  MatrixRowType,
  stakeAnswersToMatrixRows,
} from '../../survey/questionsDataviz/MatrixArray';
import { useTranslation } from '@/hooks/useTranslation';

export function SimpleMaterialityQuestionsArray({
  questionIds,
  stake,
}: {
  questionIds: string[];
  stake: SimpleMaterialityQuestionsArray_StakeFragment;
}) {
  const { t } = useTranslation();
  // Fetch answers
  const questionsQuery = useSimpleMaterialityQuestionsArray_QuestionQuery({
    variables: {
      ids: questionIds,
    },
    fetchPolicy: 'cache-and-network',
  });

  // Consolidate all answers from all questions
  const answers =
    questionsQuery.data?.surveyQuestions
      .flatMap((question) => question.answers || [])
      // Keep only provided stakes
      .map((answer) => {
        return {
          ...answer,
          stakes: answer.stakes?.filter((s) => s.stakeId === stake.id),
        };
      }) || [];

  // Columns to display
  const columns: Array<PriorityLevel> = [
    PriorityLevel.None,
    PriorityLevel.Low,
    PriorityLevel.Medium,
    PriorityLevel.High,
  ];

  const matrix: MatrixRowType[] = stakeAnswersToMatrixRows(
    answers || [],
    [stake],
    columns,
    MaterialityTypes.Financial,
  );

  if (questionsQuery.loading) {
    return <LoaderFullscreen />;
  }

  return (
    <MatrixArray
      title={t('stake.detailModal.surveys.importance_for_stakeholders')}
      matrix={matrix}
      columns={columns}
    />
  );
}
